import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import './common/fonts/AVENIRNEXTLTPRO-REGULAR_0.OTF';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.unregister();
